import { COOKIES_CONFIG } from '@belong/common';
import { Button } from '@belong/ui';
import { ChatWidget } from 'components/ChatWidget/ChatWidget';
import DottedMenu, { STYLED_MENUS } from 'components/DottedMenu/DottedMenu';
import { parseCookies } from 'nookies';
import PropTypes from 'prop-types';

const { JWT_TOKEN } = COOKIES_CONFIG;

export const MaintenanceStatusFooter = ({ menuActions, isRenter = false }) => {
  function onEdit() {
    const cookies = parseCookies();
    const jwtToken = cookies[JWT_TOKEN.name];

    window.open(
      `${process.env.NEXT_PUBLIC_SMS_ASSIST_URL}${jwtToken}`,
      '_blank',
    );
  }

  return (
    <div className="align-center my-sm flex justify-end">
      <ChatWidget isEnabled />
      {isRenter && (
        <Button variant="text" onClick={onEdit} className="ml-sm">
          EDIT
        </Button>
      )}
      {!!menuActions && !isRenter && (
        <div className="ml-lg">
          <DottedMenu
            className="cursor-default px-0 py-2sm"
            style={STYLED_MENUS.NO_BORDER_BETWEEN}
            menuItems={menuActions}
            menuButtonLabel={
              <div>
                <div>MORE</div>
              </div>
            }
          />
        </div>
      )}
    </div>
  );
};

MaintenanceStatusFooter.propTypes = {
  menuActions: PropTypes.array,
  isRenter: PropTypes.bool,
};
MaintenanceStatusFooter.defaultProps = { menuActions: null };
